export default "__VITE_ASSET__fed30288__"